import type { Optional } from '@festina-life/core'
import { useQuery } from '@tanstack/react-query'

import { UsersUserService } from '../msGraph/openapi/services/UsersUserService'

type Props = {
  userId: Optional<string>
}

export const useGetUserDetails = ({ userId }: Props) =>
  useQuery({
    queryKey: userId ? [`/users/${userId}`] : [],
    queryFn: async () => {
      if (!userId) {
        return null
      }

      return await UsersUserService.userGetUser({ userId })
    },
    staleTime: 'static',
    retry: false,
  })
